import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import AdminPanel from "@/pages/AdminPanel";
import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <LanguageProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
